<template>
  <div class="home w-100">

  <div id="container-adviser" style="margin-top:50px">
    <div class='row justify-content-center text-center'>
      <div class="col-md-5">
        <router-link to="/OnePath">
            <img width="400px" height="200px" src="../assets/OnePathLife.jpg" alt="">
        </router-link>
      </div>
      <div class="col-md-5">
        <a type="button" class="btn" href="https://staffpak.aon.co.nz/jadehttp.dll?stylecoverweb" name="button" >
            <img width="400px" height="200px" src="../assets/Aon.jpg" alt="">
        </a>
      </div>
    </div>
    <div class='row justify-content-center text-center' style="margin-top:30px">
      <div class="col-md-5">
        <router-link to="/PartnersLife">
            <img width="400px" height="200px" src="../assets/partnerslife.png" alt="">
        </router-link>
      </div>
      <div class="col-md-5">
        <a type="button" class="btn" href="https://advisers.southerncross.co.nz/For-advisers/Adviser-Gateway-login" name="button" >
            <img width="400px" height="200px" src="../assets/south-medical.jpg" alt="">
        </a>
      </div>
    </div>
  </div>

  </div>
</template>

<script>
// @ is an alias to /src
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'utilities',
  data(){
    return{
      
    }
  },
  components: {
  },
  computed:{
   ...mapState(['token'])
  },
  methods:{
      ...mapMutations(['setLogIn','checkLogIn']),      
      
  },
  created(){
  
      
  }
}
</script>
<style>


</style>